/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListAgentDelegableGrantsSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ListAgentDelegableGrantsRequest = {
  /**
   * First-class agent identifier
   */
  agentId: string;
  /**
   * Optional MCP authorization resource identifier: the toolset ID when present, otherwise the MCP server ID. Narrows discovery to this server and its project before evaluating exclusions.
   */
  toolsetId?: string | undefined;
  /**
   * Optional MCP authorization resource identifiers, discovered in one request. Each narrows discovery like toolset_id; the result is the union of candidates across all of them.
   */
  toolsetIds?: Array<string> | undefined;
  /**
   * Keep a wildcard candidate that a narrower exclusion overlaps, and return that exclusion beside it as a blocklist-scope grant, instead of omitting the candidate. Requesting both on a key needs delegated grants version 4 or later.
   */
  carryExclusions?: boolean | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListAgentDelegableGrantsSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListAgentDelegableGrantsSecurity$outboundSchema: z.ZodMiniType<
  ListAgentDelegableGrantsSecurity$Outbound,
  ListAgentDelegableGrantsSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listAgentDelegableGrantsSecurityToJSON(
  listAgentDelegableGrantsSecurity: ListAgentDelegableGrantsSecurity,
): string {
  return JSON.stringify(
    ListAgentDelegableGrantsSecurity$outboundSchema.parse(
      listAgentDelegableGrantsSecurity,
    ),
  );
}

/** @internal */
export type ListAgentDelegableGrantsRequest$Outbound = {
  agent_id: string;
  toolset_id?: string | undefined;
  toolset_ids?: Array<string> | undefined;
  carry_exclusions: boolean;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListAgentDelegableGrantsRequest$outboundSchema: z.ZodMiniType<
  ListAgentDelegableGrantsRequest$Outbound,
  ListAgentDelegableGrantsRequest
> = z.pipe(
  z.object({
    agentId: z.string(),
    toolsetId: z.optional(z.string()),
    toolsetIds: z.optional(z.array(z.string())),
    carryExclusions: z._default(z.boolean(), false),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      agentId: "agent_id",
      toolsetId: "toolset_id",
      toolsetIds: "toolset_ids",
      carryExclusions: "carry_exclusions",
      gramSession: "Gram-Session",
    });
  }),
);

export function listAgentDelegableGrantsRequestToJSON(
  listAgentDelegableGrantsRequest: ListAgentDelegableGrantsRequest,
): string {
  return JSON.stringify(
    ListAgentDelegableGrantsRequest$outboundSchema.parse(
      listAgentDelegableGrantsRequest,
    ),
  );
}
